import type { FiltersConfig } from '@rocco/ui/filter-sort/types/filter-config-section';
import { PUBLISHED_WITHIN_FILTER_KEY } from '@modules-rocco/articles/config/published-within';
import {
    ALSO_IN_FILTER_KEY,
    HAS_VIDEOS_FILTER_KEY,
} from '@modules-rocco/articles/config/article-facets';

/**
 * Facets for the revamped articles listing.
 *
 * Deliberately its own config rather than an extension of
 * `ARTICLE_FILTERS_CONFIG`: that one describes the legacy search-service facets
 * and is read by the aggregate action, so growing it would change behaviour
 * outside the flag.
 *
 * `barFilters` is empty because the bar's primary row is the category rail —
 * the pills stand in for the facet dropdowns, exactly as on /products.
 */
export const ARTICLES_REVAMP_FILTERS_CONFIG: FiltersConfig = {
    resultName: 'Article',

    barFilters: [],

    modalFilters: [
        {
            title: 'Published',
            collapsable: true,
            collapsedByDefault: false,
            // A short, fixed vocabulary, so it stays visible in the mobile
            // refine sheet rather than hiding behind a drill-in row.
            mobileRefine: 'pills',
            filters: [
                {
                    // `default` + a multiple-values state renders the option
                    // buttons; `multiple` is the checkbox column, which reads
                    // as multi-select when only one window can apply.
                    type: 'default',
                    filterKey: PUBLISHED_WITHIN_FILTER_KEY,
                },
            ],
        },
        {
            title: 'Also in',
            collapsable: true,
            collapsedByDefault: false,
            // A drill-in row rather than pills on mobile: the option list is
            // every other category, which is longer than a pill group holds.
            mobileRefine: 'drillIn',
            filters: [
                {
                    type: 'default',
                    filterKey: ALSO_IN_FILTER_KEY,
                },
            ],
        },
        {
            title: 'Media',
            collapsable: true,
            collapsedByDefault: false,
            mobileRefine: 'pills',
            filters: [
                {
                    type: 'default',
                    filterKey: HAS_VIDEOS_FILTER_KEY,
                    label: 'With video',
                },
            ],
        },
    ],
};
